<div class="action-form">
  <span class="title">{{ 'CONTACT_BALANCE_TRANSACTION.REPAY_HEADER' | translate }}</span>
  <div class="desc">{{ 'CONTACT_BALANCE_TRANSACTION.REPAY_DESCRIPTION' | translate }}</div>
  @if (forms) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-12 col-sm-5 col-lg-4">
          <app-local-date-picker [control]="form.controls['accountingDate']"></app-local-date-picker>
        </div>
      </div>
      @for (cform of $any(forms.controls); track cform; let i = $index) {
        <div class="row form-group">
          <div class="col-12">
            <h6>{{ cform.controls['companyCaption'].value }}</h6>
          </div>
          <div class="col-12 col-sm-6">
            <app-money-box [control]="cform.controls['amount']"></app-money-box>
          </div>
          <div class="col-12 col-sm-6">
            <app-select [control]="cform.controls['companyBankAccountId']" [itemsSource]="accountSelections[i]"></app-select>
          </div>
        </div>
      }
      <div class="row form-group">
        <div class="col-12">
          <button class="btn btn-active" type="submit">{{ 'OK_BTN' | translate }}</button>
          <button class="btn link-btn ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
        </div>
      </div>
    </form>
  }
</div>
